export const ActivitiesRelatedToActivitiesTypeEnum = {
  workOrder: {
    key: 1,
    value: 'WorkOrder',
  },
  unit: {
    key: 2,
    value: 'Unit',
  },
  lead: {
    key: 3,
    value: 'Lead',
  },
  portfolio: {
    key: 4,
    value: 'Portfolio',
  },
  maintenanceContract: {
    key: 5,
    value: 'MaintenanceContract',
  },
  contact: {
    key: 6,
    value: 'Contact',
  },
};
